import { useParams } from 'react-router-dom';
import { useEffectAsync } from 'utils/useEffectAsync';
import TabNav from 'components/global/TabNav';
import Loadable from 'components/global/Loadable';
import { $detail, $view } from 'signals/global.signals';
import { fetchAndSetRoomData } from 'components/views/FounderRoom/_helpers/founderRoom.resolvers';
import withDismount from 'hocs/withDismount';
import PageTitle from 'components/global/PageTitle/PageTitle';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import FounderRoomDetail from 'components/views/FounderRoom/_components/FounderRoomDetail';
import FounderRoomAnalytics from 'components/views/FounderRoom/_components/FounderRoomAnalytics';
import FounderRoomEditModal from 'components/views/FounderRoom/_components/FounderRoomEditModal';
import FounderRoomVault from 'components/views/FounderRoom/_components/FounderRoomVault';
import { handleShowModal } from 'components/global/_helpers/global.helpers';

const FounderRoom = () => {
  const { id } = useParams();

  useEffectAsync(async () => {
    await fetchAndSetRoomData(id);
  });

  return (
    <>
      <PageTitle
        Buttons={(
          <>
            <Button
              className="text-white border-dark bg-dark"
              variant="transparent"
              size="sm"
              onClick={() => window.open(`/room/${$detail.value.id}`, '_blank')}
            >
              <FontAwesomeIcon icon={faExternalLink} className="me-8" size="sm" />
              View Public Room
            </Button>
            <Button
              className="text-white border-dark bg-dark"
              variant="transparent"
              size="sm"
              onClick={() => handleShowModal('room-edit', { ...$detail.value })}
            >
              <FontAwesomeIcon icon={faEdit} className="me-8" size="sm" />
              Edit Room
            </Button>
          </>
        )}
      >
        Deal Room: {$view.value.name}
      </PageTitle>
      <Loadable signal={$view} template="spinner">
        <TabNav
          tabs={['Details', 'Data Room', 'Analytics']}
          activeTab={$view.value.activeTab}
          TabComponents={[
            <FounderRoomDetail />,
            <FounderRoomVault />,
            <FounderRoomAnalytics />,
          ]}
          async
        />
      </Loadable>
      <FounderRoomEditModal />
    </>
  );
};

export default withDismount(FounderRoom);
